import React from 'react'
import { Box } from '@mui/material'
import { ErrorMessage } from 'formik'

export const CustomErrorMessage: React.FC<{
  name: string
  component: string | React.ComponentType<{}> | undefined
}> = ({ name }) => {
  return (
    <ErrorMessage name={name}>
      {(msg) => <Box sx={{ color: 'red' }}>{msg}</Box>}
    </ErrorMessage>
  )
}
